import { Link, useLocation } from 'react-router';

import appStrings from '@/assets/constants/appStrings-no.js';
import { routes } from '@/assets/constants/routes-no.ts';

import CloseXIcon from '../../../../assets/images/close_x.svg?styled';
import HamburgerMenuIcon from '../../../../assets/images/hamburger_menu.svg?styled';
import Logo from '../../../../assets/images/logo.svg';
import { useMenuItems } from '../menu-items.tsx';
import { NavbarButtons } from '../navbar-buttons.tsx';

import TopBarItem from './top-bar-item.tsx';

interface TopBarProps {
  setSideBarOpen?(...args: unknown[]): unknown;
  isSideBarOpen?: boolean;
}

const TopBar = ({ setSideBarOpen = () => {}, isSideBarOpen = false, ...rest }: TopBarProps) => {
  const { search } = useLocation();
  const menuItems = useMenuItems();

  return (
    <header
      className="sticky top-0 z-10 flex w-full flex-col items-center bg-white px-4 shadow-[0_2px_4px_rgba(0,0,0,0.02)] md:px-6"
      {...rest}
    >
      <div
        role="toolbar"
        className="relative flex h-(--top-bar-height) w-full max-w-7xl items-center justify-center xl:justify-between"
      >
        <button
          type="button"
          onClick={setSideBarOpen}
          aria-label={isSideBarOpen ? appStrings.MENU.CLOSE : appStrings.MENU.OPEN}
          className="absolute left-2 flex cursor-pointer items-center justify-center rounded-full border-0 bg-transparent p-2 transition-colors hover:bg-v1-primary-100/5 xl:hidden"
        >
          {isSideBarOpen ? <CloseXIcon className="text-v1-primary-100" /> : <HamburgerMenuIcon />}
        </button>

        <Link prefetch="intent" aria-label={appStrings.MENU.HOME} to={`${routes.HOME}${search}`}>
          <img alt="Scoopr logo" src={Logo} className="mt-1 h-4.5 w-27.25 md:h-6.25" />
        </Link>

        <div className="hidden items-center xl:flex">
          {menuItems.map((item) => (
            <TopBarItem key={item.title} menuItem={item} />
          ))}
          <NavbarButtons className="ml-6 flex items-center gap-3" />
        </div>
      </div>
    </header>
  );
};

export default TopBar;
